import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export * from 'gsap';
export * from 'gsap/ScrollTrigger';
